import { useEffect } from "react";
import { mountNoroshiReserve, shouldMountNoroshiReserve } from "./_noroshi-reserve";

type NoroshiReserveHostProps = {
  salonId: string;
  enabled?: boolean | number | null;
};

export function NoroshiReserveHost({ salonId, enabled }: NoroshiReserveHostProps) {
  useEffect(() => {
    if (!salonId) return;
    if (!shouldMountNoroshiReserve({ enabled })) return;
    void mountNoroshiReserve(salonId);
  }, [enabled, salonId]);

  return null;
}
